import { useNavigate } from "react-router-dom";
import { MaskLine, FadeUp } from "./Reveal";

const FILES = [
    { n: "001", title: "Hot Ones: Game Night", client: "First We Feast", to: "/work/hot-ones-game-night", testid: "case-file-game-night" },
    { n: "002", title: "Slice Joint", client: "First We Feast", to: "/work/slice-joint", testid: "case-file-slice-joint" },
    { n: "003", title: "Hot Ones Wing Pong", client: "First We Feast", to: "/work/hot-ones-wing-pong", testid: "case-file-wing-pong" },
];

export default function CaseFiles() {
    const navigate = useNavigate();
    return (
        <section
            id="case-files"
            data-testid="case-files-section"
            className="bg-white px-5 pb-20 pt-24 text-black md:px-8 md:pb-28 md:pt-36"
        >
            <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em] md:text-xs">
                <FadeUp>
                    <span className="text-mmm-red">003</span> — The Case Files
                </FadeUp>
                <FadeUp className="hidden text-black/50 md:block">Fully declassified</FadeUp>
            </div>

            <h2 className="mt-10 font-display text-[clamp(3rem,9vw,9rem)] uppercase leading-[0.88] md:mt-14">
                <MaskLine delay={0.05}>The case files.</MaskLine>
            </h2>

            <div className="mt-12 md:mt-16">
                {FILES.map((f, i) => (
                    <FadeUp key={f.to} delay={i * 0.05}>
                        <button
                            type="button"
                            data-testid={f.testid}
                            onClick={() => navigate(f.to)}
                            className="group grid w-full cursor-pointer grid-cols-12 items-baseline gap-3 border-t border-black/15 px-2 py-6 text-left transition-colors duration-300 hover:bg-black hover:text-white md:px-4 md:py-8"
                        >
                            <span className="col-span-2 font-mono text-xs text-mmm-red md:col-span-1 md:text-sm">
                                ({f.n})
                            </span>
                            <span className="col-span-9 font-display text-2xl uppercase leading-none transition-transform duration-300 group-hover:translate-x-2 sm:text-4xl md:col-span-8 md:text-6xl">
                                {f.title}
                            </span>
                            <span className="col-span-12 font-mono text-[10px] uppercase tracking-[0.2em] text-black/45 transition-colors duration-300 group-hover:text-white/60 md:col-span-2 md:text-xs">
                                {f.client}
                            </span>
                            <span
                                className="col-span-1 text-right font-display text-2xl transition-all duration-300 group-hover:text-mmm-red md:text-4xl"
                                aria-hidden="true"
                            >
                                →
                            </span>
                        </button>
                    </FadeUp>
                ))}
                <div className="border-t border-black/15" />
            </div>
        </section>
    );
}
